import {Record} from 'immutable';

import {isNumber} from 'web-app/util/parsers';

export enum TYPES {
    PERCENTAGE = 'PERCENTAGE',
    FIXED = 'FIXED',
}

const CONSTANTS = {
    TYPES,
    ALL_TYPES: [TYPES.PERCENTAGE, TYPES.FIXED],
};

export class BillPayerShare extends Record<{
    ordering: number;
    type: TYPES;
    billPayerId: string;
    share: number;
}>({
    ordering: 0,
    type: TYPES.PERCENTAGE,
    billPayerId: '',
    share: 0,
}) {}

const fromAPI = data => {
    const isFixed = isNumber(data.fixed);
    const type = isFixed ? TYPES.FIXED : TYPES.PERCENTAGE;

    return new BillPayerShare({
        ...data,
        type,
        share: isFixed ? data.fixed : data.share,
    });
};

const toAPI = (billPayerShare, ordering) => {
    const {type, billPayerId, share} = billPayerShare;

    const apiObject = {
        ordering,
        billPayerId,
    };

    if (type === TYPES.FIXED) {
        return {
            ...apiObject,
            // To set a bill payer as fixed the share should be on the 'fixed' key,
            // but the backend requires the share key to be available, even when fixed is there
            share: null,
            fixed: share,
        };
    }

    return {
        ...apiObject,
        share,
    };
};

export default {
    CONSTANTS,
    record: BillPayerShare,
    fromAPI,
    toAPI,
};
